import { useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { ToastOptions, toast } from "react-toastify";
import { Input } from "../../../../components/Input/input";
import { StyledButton } from "../../../../components/Button/button";
import { theme } from "../../../../helpers/theme";
import { putSubcontractorUpdate } from "../../../../services/subcontractor/update";
import { Contractor } from "../../../../services/subcontractor/get-all/types";

export const BasicSubcontractorEditForm = (subcontractorData: Contractor[]) => {
  const { id } = useParams();

  console.log(subcontractorData)

  const sData = subcontractorData[0];


  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };


  const EditSubcontractorMutation = useMutation(putSubcontractorUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", { toastId: "EditSuccessfully", ...settings });

    },
  });



  const activeValue = (active: Boolean | string) => {
    if (typeof active == "boolean") {
      return active
    } else {
      return active === "true" ? true : false
    }
  }

  const validationSchema = yup.object({
    nazwa_wykonawcy: yup
      .string()
      .max(50, "Nazwa nie może być dłuższa niż 50 znaków")
      .required("Nazwa jest wymagana"),
    nip: yup
      .number()
      .typeError("Błędny format!")
      .required("NIP jest wymagany")
      .min(1000000000, "NIP musi mieć 10 cyfr")
      .max(9999999999, "NIP musi mieć 10 cyfr"),
    // weryfikacja: yup
    //   .number()
    //   .required("Weryfikacja jest wymagana"),
    telefon: yup
      .number()
      .typeError("Błędny format!")
      .required("Telefon jest wymagany")
      .min(100000000, "Telefon musi mieć 9 cyfr")
      .max(999999999, "Telefon musi mieć 9 cyfr"),
    email: yup
      .string()
      .required("Email jest wymagany")
      .email("Błędny format adresu E-mail"),
    // info_dodatkowe: yup
    //   .string()
    //   .max(100, "Informacje dodatkowe nie mogą być dłuższe niż 100 znaków"),
    aktywny: yup
      .mixed()
      .required("pole Aktywny jest wymagane jest wymagany"),

  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id_wykonawcy: id,
      nazwa_wykonawcy: sData?.nazwa_wykonawcy,
      nip: sData?.nip,
      // weryfikacja: sData?.weryfikacja ? sData?.weryfikacja : Number(0),
      telefon: sData?.telefon,
      email: sData?.email,
      // info_dodatkowe: sData?.info_dodatkowe,
      aktywny: sData?.aktywny === true ? "true" : "false",
      // adres: sData!==null ? sData.adres_siedziby.id_adres : null
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id: values.id_wykonawcy,
        nazwa_wykonawcy: values.nazwa_wykonawcy,
        nip: values.nip,
        telefon: values.telefon,
        email: values.email,
        aktywny: activeValue(values.aktywny),
        adres_id: sData.adres_siedziby?.id_adres
      };
      EditSubcontractorMutation.mutate(body);



    },
  });


  // if (EditClient.isLoading) {
  //   return <LoadingBackDrop loading={true} />;
  // }
  return (
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <Input
          label="Nazwa"
          id="nazwa"
          name="nazwa_wykonawcy"
          value={formik.values.nazwa_wykonawcy}
          onChange={formik.handleChange}
          error={formik.touched.nazwa_wykonawcy && Boolean(formik.errors.nazwa_wykonawcy)}
          helperText={formik.touched.nazwa_wykonawcy && formik.errors.nazwa_wykonawcy}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="NIP"
          id="nip"
          name="nip"
          value={formik.values.nip}
          onChange={formik.handleChange}
          error={formik.touched.nip && Boolean(formik.errors.nip)}
          helperText={formik.touched.nip && formik.errors.nip}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        {/* <FormControl fullWidth>
          <InputLabel id="weryfikacja-label">Weryfikacja</InputLabel>
          <Select
            placeholder="Weryfikacja"
            labelId="weryfikacja-label"
            label="Weryfikacja"
            id="weryfikacja"
            name="weryfikacja"

            value={formik.values.weryfikacja}
            onChange={formik.handleChange}
            // error={formik.touched.weryfikacja && Boolean(formik.errors.weryfikacja)}
            // helperText={formik.touched.weryfikacja && formik.errors.weryfikacja}
            onBlur={formik.handleBlur}
            // variant="filled"
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Niezweryfikowany</MenuItem>
            <MenuItem value={1}>Zweryfikowany pozytywnie</MenuItem>
            <MenuItem value={2}>Zweryfikowany negatywnie</MenuItem>
          </Select>
        </FormControl> */}

        <Input
          label="Telefon"
          id="telefon"
          name="telefon"
          value={formik.values.telefon}
          onChange={formik.handleChange}
          error={formik.touched.telefon && Boolean(formik.errors.telefon)}
          helperText={formik.touched.telefon && formik.errors.telefon}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Email"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        {/* <Input
          label="Info dodatkowe"
          id="info_dodatkowe"
          name="info_dodatkowe"
          value={formik.values.info_dodatkowe}
          onChange={formik.handleChange}
          error={formik.touched.info_dodatkowe && Boolean(formik.errors.info_dodatkowe)}
          helperText={formik.touched.info_dodatkowe && formik.errors.info_dodatkowe}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        /> */}
        <FormLabel id="active-label">Aktywny</FormLabel>
        <RadioGroup
          aria-labelledby="active-label"
          defaultValue="true"
          name="aktywny"
          value={formik.values.aktywny}
          onChange={formik.handleChange}
          // error={formik.touched.aktywny && Boolean(formik.errors.aktywny)}
          // helperText={formik.touched.aktywny && formik.errors.aktywny}
          onBlur={formik.handleBlur}
        >
          <FormControlLabel value="true" control={<Radio />} label="Aktywny" />
          <FormControlLabel value="false" control={<Radio />} label="Niekatywny" />
        </RadioGroup>

        <StyledButton disabled={!formik.isValid || EditSubcontractorMutation.isLoading} type="submit" variant="contained">
          Zapisz
        </StyledButton>
      </FormWrapper>
    </BasicFormWrapper>
  );
};

export default BasicSubcontractorEditForm;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;


